export const KNOWLEDGE_BASE = {
  SUPPLY_CHAIN:
    'https://knowledge-base.yieldbird.com/prebid-stack/schain-supply-chain-object-module#block-4958f79daa054b9a97e62388439167a7',
} as const
